import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileContext } from "../../../context/ContextProfile";
import Houses from "./Houses";
import HousesFabero from "./HousesFabero";
import Jobs from "./Jobs";
import ProgressiveImg from "./ProgressiveImg";
import EmptyState from "./EmptyState";

const PAGE_SIZE = 15;

function youtube_parser(url) {
  var regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
}

function removeFileExtension(filename) {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) return filename;
  return filename.substring(0, lastDotIndex);
}

function Grid({ images, isJob, isExperience, isHousing }) {
  const { village, modifySelectedImage } = useContext(ProfileContext);
  const navigate = useNavigate();
  const [visible, setVisible] = useState(PAGE_SIZE);
  const sentinelRef = useRef(null);

  const hasMore = !!images && visible < images.length;

  // Infinite scroll: load the next page as the sentinel approaches the viewport.
  useEffect(() => {
    if (!hasMore) return;
    const el = sentinelRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible((v) => v + PAGE_SIZE);
        }
      },
      { rootMargin: "600px 0px" }, // start loading well before it's on screen
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, visible]);

  const onImageClick = (image) => {
    const filename =
      image.isVideo == 1
        ? youtube_parser(image.path[0])
        : removeFileExtension(image.path[0]);
    modifySelectedImage(image);
    navigate(`/images/${filename}`);
  };

  // Village-specific sections
  if (isHousing) {
    if (village.code === "graus") return <Houses />;
    if (village.code === "fabero") return <HousesFabero />;
    return <EmptyState animation="coming-soon">Próximamente</EmptyState>;
  }

  if (isJob) {
    if (village.code === "graus") return <Jobs />;
    return <EmptyState animation="coming-soon">Próximamente</EmptyState>;
  }

  if (isExperience) {
    return <EmptyState animation="coming-soon">Próximamente</EmptyState>;
  }

  // Main photo grid
  if (!images || images.length === 0) {
    return (
      <EmptyState icon="fa-camera" title="Sin fotos todavía">
        Este perfil aún no tiene publicaciones.
      </EmptyState>
    );
  }

  const shown = images.slice(0, visible);

  return (
    <>
      <div className="ig-grid">
        {shown.map((image, index) => {
          const isVideo = image.isVideo == 1;
          const src = isVideo
            ? `https://img.youtube.com/vi/${youtube_parser(image.path[0])}/0.jpg`
            : `https://aldealista.com/p/${image.path[0]}`;

          return (
            <div
              key={image.id || index}
              className="ig-cell"
              onClick={() => onImageClick(image)}
            >
              <ProgressiveImg src={src} alt={image.title} />
              {isVideo ? (
                <i className="fa fa-play-circle ig-badge" aria-hidden="true"></i>
              ) : (
                image.path.length > 1 && (
                  <i className="fa fa-clone ig-badge" aria-hidden="true"></i>
                )
              )}
              {image.title && <span className="ig-caption">{image.title}</span>}
            </div>
          );
        })}
      </div>

      {hasMore && (
        <div ref={sentinelRef} className="ig-sentinel" aria-hidden="true" />
      )}
    </>
  );
}

export default Grid;
